module.exports = __webpack_public_path__ + "img/energy.3bc0746.webp";